import * as yup from 'yup';
import { InitiativeType } from '../utils/enums';
const MB = 1024 * 1024;

export const InitiativeValidationSchema = yup.object().shape({
	type: yup.number().positive('Typ jest polem wymaganym').required('Typ jest polem wymaganym'),
	title: yup
		.string()
		.required('Temat/tytuł inicjatywy obywatelskiej jest polem wymaganym')
		.max(100, 'Temat/tytuł inicjatywy obywatelskiej może zawierać maksymalnie 100 znaków'),
	thematicAreaId: yup.number().required('Kategoria jest polem wymaganym').min(1, 'Kategoria musi zostać określona'),
	districtId: yup.number().positive('Obszar jest polem wymaganym'),
	content: yup
		.string()
		.max(2000, 'Treść inicjatywy obywatelskiej może zawierać maksymalnie 2000 znaków')
		.required('Treść inicjatywy jest polem wymaganym'),
	replyTo: yup
		.string()
		.when(
			'isAuth',
			(isAuth) =>
				isAuth
					? yup.string().nullable()
					: yup
							.string()
							.required('Adres e-mail jest wymagany')
							.email('Wartość w polu Adres e-mail nie jest prawidłowym formatem adresu e-mail')
		),
	isAuth: yup.boolean(),
	attachments: yup
		.array()
		.test('attachments', 'Przekroczono dopuszczalną łączną wielkość załączników', function(attachments) {
			let size = 0;
			let allMaxSize = this.parent.attachmentConfiguration.maxAllAttachmentsSize * MB;
			if (attachments.length > 0) {
				attachments.forEach((item) => (size += item.size));

				return size <= allMaxSize;
			}
			return true;
		})
		.test('attachments', 'Przekroczono dopuszczalną ilość załączników', function(attachments) {
			return attachments.length <= this.parent.attachmentConfiguration.maxAttachmentQuantity;
		}),
	locationDescription: yup.string().max(200, 'Opis lokalizacji może zawierać maksymalnie 200 znaków'),
	cost: yup.string().when(
		'type',
		(type) =>
			type === InitiativeType.BudgetProject
				? yup
						.string()
						.required('Szacunkowy koszt jest polem wymaganym')
						.matches(
							/^[0-9]+([,]?[0-9]+)?$/,
							'Nieprawidłowy format. Prawidłowe formaty: 1,23 lub 1,2 lub 123'
						)
						.test(
							'Prevent trillion value',
							'Maksymalna wartość szacunkowego kosztu nie może przekraczać 1 000 000 000 000',
							function(value) {
								if (!value) {
									return true;
								}

								const cost = parseFloat(value).toFixed(2);
								return cost < 1000000000000;
							}
						)
				: yup.string()
	)
});


export const ConsultationInitiativeValidationSchema = yup.object().shape({
	type: yup.number().positive('Typ jest polem wymaganym').required('Typ jest polem wymaganym'),
	title: yup
		.string()
		.required('Temat/tytuł inicjatywy obywatelskiej jest polem wymaganym')
		.max(100, 'Temat/tytuł inicjatywy obywatelskiej może zawierać maksymalnie 100 znaków'),
	thematicAreaId: yup.number().required('Kategoria jest polem wymaganym').min(1, 'Kategoria musi zostać określona'),
	districtId: yup.number().positive('Obszar jest polem wymaganym'),
	content: yup
		.string()
		.max(2000, 'Treść może zawierać maksymalnie 2000 znaków')
		.required('Treść jest polem wymaganym'),
	replyTo: yup
		.string()
		.when(
			'isAuth',
			(isAuth) =>
				isAuth
					? yup.string().nullable()
					: yup
							.string()
							.required('Adres e-mail jest wymagany')
							.email('Wartość w polu Adres e-mail nie jest prawidłowym formatem adresu e-mail')
		),
	isAuth: yup.boolean(),
	attachments: yup
		.array()
		.test('attachments', 'Przekroczono dopuszczalną łączną wielkość załączników', function(attachments) {
			let size = 0;
			let allMaxSize = this.parent.attachmentConfiguration.maxAllAttachmentsSize * MB;
			if (attachments.length > 0) {
				attachments.forEach((item) => (size += item.size));

				return size <= allMaxSize;
			}
			return true;
		})
		.test('attachments', 'Przekroczono dopuszczalną ilość załączników', function(attachments) {
			return attachments.length <= this.parent.attachmentConfiguration.maxAttachmentQuantity;
		}),
	locationDescription: yup.string().max(200, 'Opis lokalizacji może zawierać maksymalnie 200 znaków'),
	cost: yup.string().when(
		'type',
		(type) =>
			type === InitiativeType.BudgetProject
				? yup
						.string()
						.required('Szacunkowy koszt jest polem wymaganym')
						.matches(
							/^[0-9]+([,]?[0-9]+)?$/,
							'Nieprawidłowy format. Prawidłowe formaty: 1,23 lub 1,2 lub 123'
						)
						.test(
							'Prevent trillion value',
							'Maksymalna wartość szacunkowego kosztu nie może przekraczać 1 000 000 000 000',
							function(value) {
								if (!value) {
									return true;
								}

								const cost = parseFloat(value).toFixed(2);
								return cost < 1000000000000;
							}
						)
				: yup.string()
	)
});
